import React from 'react';
import PropTypes from 'prop-types';

import { BulkActionPackageDropdown } from './container';
import style from './style.module.less';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import DimensionsLabel from '../../../../fulfillment-planner/dimensions/label';
import PackageLabel from '../../../../fulfillment-planner/package/label';
import { ConvertedDimensionsInput } from '../../../converted-dimensions-input/converted-dimensions-input';

const defaultFilter = () => true;
const defaultFilters = [defaultFilter];

export const PackageWithDimensions = ({
  onPackageSelected,
  packageFilters = defaultFilters,
  selectedPackageIds = emptyArray,
  dimensions = emptyObject,
  onSetDimensions,
  shouldRenderDimensions = false,
}) => {
  return (
    <div className={style['drawer-bulk-package']}>
      <div className={style['package-input-label']}>
        <PackageLabel />
      </div>
      <BulkActionPackageDropdown
        onPackageSelected={onPackageSelected}
        packageFilters={packageFilters}
        selectedPackageIds={selectedPackageIds}
      />
      {shouldRenderDimensions ? (
        <>
          <div className={style['package-input-label']}>
            <DimensionsLabel />
          </div>
          <ConvertedDimensionsInput dimensions={dimensions} inputClassName={style['size-input']} onChange={onSetDimensions} />
        </>
      ) : null}
    </div>
  );
};

PackageWithDimensions.propTypes = {
  onPackageSelected: PropTypes.func.isRequired,
  packageFilters: PropTypes.arrayOf(PropTypes.func),
  selectedPackageIds: PropTypes.array,
  dimensions: PropTypes.object,
  onSetDimensions: PropTypes.func.isRequired,
  shouldRenderDimensions: PropTypes.bool,
};
